import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import Constants from '../../../definitions/constants';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import ToggleSection from '../common/interface/toggleSection';
import GlassPopup from '../common/interface/glassPopup';
import File from '../common/inputs/file';
import ErrorFeedback from '../common/feedback/errorFeedback';
import SelectList from '../common/inputs/selectList';
import TextBox from '../common/inputs/textBox';
import Select from '../common/inputs/select';
import RGBPicker from '../common/inputs/rgbPicker';

const CustomerFormPopup = props => {
  const {
    handleShowPopup,
    handleButton,
    loadingButton,
    fullLoading,
    statusLoading,
    statusButton,
    formData,
    errors,
    popupState,
    handleOnChangeCustomerForm,
    connectorsList,
    customerData,
    handleOnUpdateCustomerCustomThemeColor,
  } = props;
  var connectorsSelectedObj = InterfaceTooling.getSelectArrayFromArray(customerData.connectors, false);
  var connectorsListObj = InterfaceTooling.getSelectArrayFromArray(connectorsList, false);
  var connectorsDataOptionsAux =  
    (connectorsSelectedObj && connectorsSelectedObj.length != 0) ? 
    connectorsListObj.filter(item => item.value != connectorsSelectedObj[0].value) :
    connectorsListObj;
  return (
    <GlassPopup
      className="form_popup customer_popup"
      title={(<FormattedMessage id="dashboard.customerForm.title"/>)}
      buttonText={(<FormattedMessage id="dashboard.customerForm.button"/>)}
      {...props}
    >
      <ErrorFeedback
        status={statusButton}
        fieldErrors={errors}
        localesFieldsPath="dashboard.customerForm"
      />
      {(statusLoading==200) && (
        <div>
          <p className="form_paragraph">
            <FormattedMessage id="dashboard.customerForm.file_help"/>
          </p>
          {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"customer.logo_path")) && (
            <p className="form_paragraph">
              <strong><FormattedMessage id="dashboard.customerForm.logo_loaded"/></strong>
            </p>            
          )}
          <File
            id="logo_file_upload"
          />
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            dataType={Constants.selectKeys.metric.dataType.NUMBER}
            type={Constants.interface.inputs.type.TEXT}
            id="reports_logo_width"
            data-path="reports_logo_width"
            value={customerData.reports_logo_width}
            onChange={handleOnChangeCustomerForm}
            labelLocale={<FormattedMessage id="dashboard.customerForm.reports_logo_width"/>}
            className={("reports_logo_width" in errors) ? "has_error" : null}
          />
          <label className="form_info">
            <FormattedMessage 
              id={"dashboard.customerForm.reports_logo_width_help"}
            />
          </label>
          {(false) && ( 
            <Select 
              id="context"
              data-path="context"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(customerData,"context")}
              onChange={handleOnChangeCustomerForm}
              labelLocale={<FormattedMessage id="dashboard.customerForm.context"/>}
              options={InterfaceTooling.getSelectArray("selectKeys.calculationUnit.globalLabelContext", "common.globalCalculationUnitLabelContextSelectValues", false)}
            />
          )}
          <SelectList       
            values={connectorsSelectedObj}
            onChange={handleOnChangeCustomerForm}
            data-path="connectors"
            addSelectLocale={<FormattedMessage id="dashboard.customerForm.connectorsForm.addConnectorValue"/>}
            labelLocale={<FormattedMessage id="dashboard.customerForm.connectorsForm.entityNamePluralFirstUpper"/>}
            noMoreOptionsLocale={intl.formatMessage({id:"dashboard.customerForm.connectorsForm.noMoreOptions"})}
            valueAccesor={"value"}
            labelAccesor={"label"}
            options={InterfaceTooling.getSelectArrayFromArrayOfObjects(connectorsDataOptionsAux, "value", "label", true, intl.formatMessage({id: "dashboard.customerForm.connectorsForm.addConnectorValue"}))}
            connector={true}
          />
          {(false) && (   
            <ToggleSection title={<FormattedMessage id="dashboard.customerForm.themeColorTitle"/>}>
              <Select 
                id="theme"
                data-path="theme"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(customerData,"theme")}
                onChange={handleOnChangeCustomerForm}
                labelLocale={<FormattedMessage id="dashboard.customerForm.theme"/>}
                options={InterfaceTooling.getSelectArray("selectKeys.userThemes", "dashboard.customerForm.userThemeValues", false)}
              />
              <Select 
                id="theme_color"
                data-path="theme_color"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(customerData,"theme_color")}
                onChange={handleOnChangeCustomerForm}
                labelLocale={<FormattedMessage id="dashboard.customerForm.theme_color"/>}
                options={InterfaceTooling.getSelectArray("selectKeys.userColors", "dashboard.customerForm.userColorValues", false)}
              />
              {(JavascriptUtilsTooling.getObjectStringPathKeyValue(customerData,"theme_color") == "user_theme") && (
                <RGBPicker
                  color={"#" + JavascriptUtilsTooling.getObjectStringPathKeyValue(customerData,"theme_color_custom")}
                  onChange={handleOnUpdateCustomerCustomThemeColor}
                  disableAlpha={true}
                />
              )}
            </ToggleSection>
          )}
        </div>
      )}
    </GlassPopup>
  );
};

export default CustomerFormPopup;



// WEBPACK FOOTER //
// ./source/client/components/dashboard/customerFormPopup.jsx